import React from 'react';

const AddDataset = ({ onClick }) => {
  return (
    <div style={{ margin: '12px 0', marginRight: 0, textAlign: 'right' }}>
      <button
        onClick={onClick}
        style={{
          padding: '8px 16px',
          backgroundColor: '#1976d2',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '14px',
        }}
        aria-label="Add New Datasets"
      >
        Add New Datasets
      </button>
    </div>
  );
};

export default AddDataset;
